export const getBasketCount = (product, basketList) => {
  return basketList?.find(item => item.productId === product?.id)?.quantity
}
